module.exports = __webpack_public_path__ + "static/media/mac_comp.b810fd35.svg";